import React from "react";
import FlexComponent from "../FlexComponent";
import { contactDisplayName, ghlContactUrl } from "../../utils/contacts";

const pillStyle = { borderRadius: "1rem", padding: "0 .5rem", fontSize: "11px", whiteSpace: "nowrap" };

// Co-borrowers on the app card, laid out on the same 40/60 grid as the applicant fields.
// Hidden when the response has no co_borrowers (older backend) or the list is empty.
function CoBorrowers({ coBorrowers, locationId }) {
    if (!Array.isArray(coBorrowers) || coBorrowers.length === 0) return null;

    return (
        <div className="applicantDivs" style={{ width: "100%" }}>
            <div style={{ fontSize: "14px", color: "#B1B1B1", marginBottom: ".4rem" }}>Co-borrowers</div>
            <FlexComponent flexDirection="column" alignItems="start" gap=".5rem">
                {coBorrowers.map((person) => (
                    <FlexComponent key={person.id} className="applicantContainer" gap="1rem" alignItems="start">
                        <FlexComponent justifyContent="start" gap=".5rem" flexWrap="wrap" style={{ width: "40%" }}>
                            <span>{contactDisplayName(person)}</span>
                            {person.ghl_contact_id ? (
                                locationId && (
                                    <button
                                        type="button"
                                        onClick={() => window.open(ghlContactUrl(locationId, person.ghl_contact_id), "_blank")}
                                        style={{ ...pillStyle, borderRadius: "6px", padding: "2px .6rem", background: "transparent", border: "1px solid grey", color: "white", fontWeight: "bold", cursor: "pointer" }}
                                    >
                                        <i className="pi pi-external-link" style={{ fontSize: "10px", marginRight: ".35rem" }}></i>View Contact
                                    </button>
                                )
                            ) : (
                                <span
                                    title="Not linked to GHL yet, so texts and calls aren't tracked. Syncing happens in the background."
                                    style={{ ...pillStyle, border: "1px solid #6b6b6b", color: "#8C8C8C" }}
                                >
                                    Not synced
                                </span>
                            )}
                        </FlexComponent>
                        <FlexComponent justifyContent="start" gap="1.5rem" flexWrap="wrap" style={{ width: "60%" }}>
                            {person.phone && <span><i className="pi pi-phone" style={{ fontSize: "11px", marginRight: ".35rem", color: "#B1B1B1" }}></i>{person.phone}</span>}
                            {person.email && <span style={{ wordBreak: "break-all" }}><i className="pi pi-envelope" style={{ fontSize: "11px", marginRight: ".35rem", color: "#B1B1B1" }}></i>{person.email}</span>}
                        </FlexComponent>
                    </FlexComponent>
                ))}
            </FlexComponent>
        </div>
    );
}

export default CoBorrowers;
